import { MutationStatus } from '@tanstack/react-query';

export const getModalStatus = (statuses: MutationStatus[]): MutationStatus => {
  if (statuses[0] === 'idle') {
    return 'idle';
  }

  if (statuses.every((s) => s === 'success')) {
    return 'success';
  }

  if (statuses.some((s) => s === 'error')) {
    return 'error';
  }

  return 'pending';
};
